import { Component, OnInit } from '@angular/core';
import { CookieService } from 'ngx-cookie-service';
import { SpraPriceJustificationParams } from 'src/app/Models/ops';
import { NotificationService } from 'src/app/Services/notification.service';
import { Utility } from 'src/app/Utilities/utility';

@Component({
  selector: 'app-spra-price-justification',
  templateUrl: './spra-price-justification.component.html',
  styleUrls: ['./spra-price-justification.component.css']
})
export class SpraPriceJustificationComponent implements OnInit {
  public SpraPriceJustificationParams: SpraPriceJustificationParams;
  private utility: Utility;
  constructor(private cookieService: CookieService,
    private _NotificationService: NotificationService) {
    this.SpraPriceJustificationParams = new SpraPriceJustificationParams();
    this.utility = new Utility(this.cookieService);
  }

  ngOnInit(): void {
  }

  Validation(): boolean {
    if (!this.utility.CheckStringRequired(this.SpraPriceJustificationParams.BoRemarks?.toString().trim())) {
      this._NotificationService.showError("Please enter price justification remarks.", "Price Justification");
      return false
    }
    return true ;

  }

}
